import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { logos, socialMediaUrl } from "../Details";

/* Nav link hover + active styles (white default text) */
const navLinkClass = ({ isActive }) =>
  `relative px-2 py-1 transition-all duration-300
   text-white
   hover:text-purple-600 hover:-translate-y-0.5
   after:absolute after:left-0 after:-bottom-1 after:h-[2px]
   after:w-0 after:bg-purple-500 after:transition-all after:duration-300
   hover:after:w-full
   ${
     isActive
       ? "text-purple-600 after:w-full"
       : ""
   }`;

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { linkdein, github, twitter } = socialMediaUrl;

  const toggleClass = () => setIsOpen(!isOpen);

  return (
    <header className="container mx-auto md:flex justify-between py-2 max-width relative z-20">
      {/* Logo + Mobile Menu */}
      <div className="flex justify-between items-center py-2 md:py-10">
        <NavLink to="/">
          <img className="w-14" src={logos.logogradient} alt="logo" />
        </NavLink>

        {/* Mobile menu icon */}
        <div onClick={toggleClass} className="cursor-pointer md:hidden">
          <svg
            className="stroke-white"
            width="25"
            height="20"
            viewBox="0 0 16 13"
            fill="none"
          >
            <path
              d="M1.4375 1.3125H14.5625M1.4375 11.3125H14.5625M1.4375 6.3125H14.5625"
              strokeWidth="1.875"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`${!isOpen ? "hidden" : ""} text-center md:flex justify-between`}>
        <ul className="font-medium md:flex items-center md:space-x-5 md:mr-10">
          <li><NavLink to="/" onClick={toggleClass} className={navLinkClass}>Home</NavLink></li>
          <li><NavLink to="/about" onClick={toggleClass} className={navLinkClass}>About</NavLink></li>
          <li><NavLink to="/technologies" onClick={toggleClass} className={navLinkClass}>Technologies</NavLink></li>
          <li><NavLink to="/certifications" onClick={toggleClass} className={navLinkClass}>Certifications</NavLink></li>
          <li><NavLink to="/contact" onClick={toggleClass} className={navLinkClass}>Contact</NavLink></li>
        </ul>

        {/* Social Icons */}
        <ul className="flex justify-evenly items-center my-5 md:my-0 md:space-x-5 md:mr-5">

          {/* Twitter */}
          <li>
            <a href={twitter} target="_blank" rel="noreferrer noopener">
              <svg
                className="w-6 h-6 fill-gray-200 hover:fill-purple-600 transition-colors"
                viewBox="0 0 24 24"
              >
                <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775
                1.014-.611 1.794-1.574 2.163-2.724
                -.951.564-2.005.974-3.127 1.195
                -.897-.957-2.178-1.555-3.594-1.555
                -2.723 0-4.928 2.204-4.928 4.928
                0 .39.045.765.127 1.124
                -4.094-.205-7.725-2.165-10.164-5.144
                -.424.722-.666 1.561-.666 2.475
                0 1.708.87 3.213 2.188 4.096
                -.807-.026-1.566-.247-2.228-.616v.061
                c0 2.385 1.693 4.374 3.946 4.827
                -.413.111-.849.171-1.296.171
                -.314 0-.615-.03-.916-.086
                .631 1.953 2.445 3.377 4.6 3.417
                -1.68 1.319-3.809 2.105-6.102 2.105
                -.39 0-.779-.023-1.17-.067
                2.189 1.394 4.768 2.209 7.557 2.209
                9.054 0 14-7.496 14-13.986
                0-.209 0-.42-.016-.63
                .962-.689 1.8-1.56 2.46-2.548z" />
              </svg>
            </a>
          </li>

          {/* LinkedIn */}
          <li>
            <a href={linkdein} target="_blank" rel="noreferrer noopener">
              <svg
                className="w-6 h-6 fill-gray-200 hover:fill-purple-600 transition-colors"
                viewBox="0 0 24 24"
              >
                <path d="M20.447 20.452h-3.554v-5.569
                c0-1.328-.027-3.037-1.852-3.037
                -1.853 0-2.136 1.445-2.136 2.939
                v5.667H9.351V9h3.414v1.561h.047
                c.477-.9 1.637-1.85 3.37-1.85
                3.601 0 4.268 2.37 4.268 5.455v6.286z
                M5.337 7.433c-1.144 0-2.063-.926-2.063-2.065
                0-1.138.92-2.063 2.063-2.063
                1.14 0 2.064.925 2.064 2.063
                0 1.139-.925 2.065-2.064 2.065z
                M6.878 20.452H3.795V9h3.083v11.452z
                M22.225 0H1.771C.792 0 0 .774 0 1.727v20.545
                C0 23.227.792 24 1.771 24h20.451
                C23.2 24 24 23.227 24 22.273V1.727
                C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </li>

          {/* GitHub */}
          <li>
            <a href={github} target="_blank" rel="noreferrer noopener">
              <svg
                className="w-6 h-6 fill-gray-200 hover:fill-purple-600 transition-colors"
                viewBox="0 0 24 24"
              >
                <path d="M12 0C5.37 0 0 5.37 0 12
                c0 5.303 3.438 9.8 8.205 11.385
                .6.113.82-.258.82-.577
                0-.285-.01-1.04-.015-2.04
                -3.338.724-4.042-1.61-4.042-1.61
                -.546-1.387-1.333-1.757-1.333-1.757
                -1.09-.745.083-.729.083-.729
                1.205.085 1.84 1.237 1.84 1.237
                1.07 1.834 2.809 1.304 3.495.997
                .108-.776.418-1.305.762-1.605
                -2.665-.305-5.466-1.332-5.466-5.93
                0-1.31.469-2.381 1.236-3.221
                -.124-.303-.536-1.523.117-3.176
                0 0 1.008-.322 3.301 1.23
                .957-.266 1.983-.399 3.003-.404
                1.02.005 2.047.138 3.006.404
                2.291-1.552 3.297-1.23 3.297-1.23
                .655 1.653.243 2.873.12 3.176
                .77.84 1.235 1.911 1.235 3.221
                0 4.61-2.804 5.624-5.475 5.921
                .43.371.823 1.102.823 2.222
                0 1.606-.015 2.896-.015 3.286
                0 .321.216.694.825.576
                C20.565 21.796 24 17.299 24 12
                24 5.37 18.627 0 12 0z" />
              </svg>
            </a>
          </li>

        </ul>
      </nav>
    </header>
  );
}

export default Header;
